import React from "react";
import { motion } from "framer-motion";
import { FileUp, Calculator, Stamp, Truck } from "lucide-react";

const steps = [
  {
    icon: FileUp,
    title: "Envie seus documentos",
    desc: "Compartilhe seus arquivos em formato PDF pelo WhatsApp ou e-mail. Análise confidencial e sigilosa.",
  },
  {
    icon: Calculator,
    title: "Receba o orçamento",
    desc: "Resposta rápida com valor, prazo e condições — sem compromisso.",
  },
  {
    icon: Stamp,
    title: "Tradução e validação",
    desc: "Tradução juramentada com fé pública, assinada digital e fisicamente.",
  },
  {
    icon: Truck,
    title: "Entrega oficial",
    desc: "Entrega digital (GOV.BR Ouro) ou impressa via correio em todo o Brasil.",
  },
];

const HowItWorks = () => {
  return (
    <section id="processo" data-testid="how-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-2xl mx-auto mb-20">
          <p className="overline mb-5"><span className="gold-rule mr-3 align-middle" />Como funciona</p>
          <h2 className="font-serif-display text-3xl md:text-4xl lg:text-5xl tracking-tight leading-tight">
            Quatro passos. <span className="italic">Zero complicação.</span>
          </h2>
          <p className="mt-5 text-sm md:text-base text-[#475569]">
            <span className="text-[#0A1128] font-medium">Importante:</span> todos os documentos devem ser enviados em formato <span className="text-[#0A1128] font-medium">PDF</span> para preservar a integridade e a legibilidade dos originais.
          </p>
        </div>

        <div className="relative">
          {/* connecting line - desktop */}
          <div className="hidden lg:block absolute top-12 left-12 right-12 h-px bg-[#E2E8F0]" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.8, delay: i * 0.12 }}
                  data-testid={`step-${i}`}
                  className="relative"
                >
                  {/* number badge */}
                  <div className="relative flex items-center gap-4 mb-6">
                    <div className="relative w-24 h-24 bg-[#FAFAFA] border border-[#E2E8F0] flex items-center justify-center rounded-sm">
                      <Icon size={28} strokeWidth={1.25} className="text-[#0A1128]" />
                      <span className="absolute -top-3 -right-3 bg-[#0A1128] text-[#C5A059] text-[11px] tracking-[0.2em] font-serif-display px-2 py-1 rounded-sm">
                        0{i + 1}
                      </span>
                    </div>
                  </div>

                  <h3 className="font-serif-display text-xl md:text-2xl text-[#0A1128] leading-tight mb-3">
                    {s.title}
                  </h3>
                  <p className="text-sm text-[#475569] leading-relaxed pr-4">{s.desc}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
